import React from 'react'
import Files from '../file/Files'

// TODO: figure out the reason why the Files component was not re-rendered
// upon route change, if it is put directly in the App.js component.
// But when it is put inside Starred component like this, it was re-rendered correctly.
export default function Starred() {
  return <Files isStarred={true} />
}
